import React from 'react';
import PropTypes from 'prop-types';
import { useField, ErrorMessage } from 'formik';
import styled from 'styled-components';
import { gray, accent, primary, tertiary, white } from '~/components/mixins/color';

const Group = styled.div`
  display: grid;
  position: relative;
  margin: ${(props) => props.noMargin ? '0' : '0 0 10px'};
  width: 100%;

  textarea {
    font-family: 'Roboto';
    background: ${primary.hex()};
    border: 2px solid ${tertiary.hex()};
    border-radius: 3px;
    padding: 19px 40px 6px 10px;
    width: 100%;
    color: ${white.hex()};
    position: relative;
    transition: border-color 0.2s ease-in 0s;
    resize: none;

    &:focus-within {
      border-color: ${accent.hex()};
    }
    &:disabled {
      background-color: ${primary.lighten(0.5).hex()};
      color: ${gray.hex()};
    }
    &:focus + label,
    &:not([value='']) + label {
      font-size: 70%;
      transform: translate3d(0, -100%, 0);
      opacity: 1;
      top: 20px;
      color: ${white.hex()};
    }
    &:not([value='']) + label {
      color: ${gray.hex()};
    }
    &:focus + label {
      color: ${white.hex()};
    }
    &:focus::placeholder {
      color: ${white.hex()};
    }
    & + label {
      position: absolute;
      top: 15px;
      padding-left: 10px;
      transition: all 200ms;
      color: ${gray.hex()};
      opacity: 0.7;
    }
  }
`;

const TextArea = ({ label, name, rows, noMargin, hasError, ...rest }) => {
  const [field] = useField({ name })
  return (
    <>
      <Group noMargin={noMargin}>
        <textarea
          {...rest}
          {...field}
          rows={rows}
          value={field.value || ''}
          placeholder={label}
          className={!!hasError ? 'error' : ''}
          />
          {field.value && <label htmlFor={name}>{label}</label>}
      </Group>
      <ErrorMessage name={name} className="error" component="div" />
    </>
  );
}

TextArea.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  rows: PropTypes.number,
  hasError: PropTypes.bool,
};

TextArea.defaultProps = {
  hasError: false,
  rows: 3
};

export default TextArea;
